<template>
  <el-dialog 
    :modal-append-to-body="false"
    :title="openType === 'add' ? '新增快递' : '编辑快递'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="50%"
    custom-class="customModal">
    
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item prop="shipping_name" class="formItemFill" label="快递名称">
            <el-input v-model="formValue.shipping_name" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="shipping_code" class="formItemFill" label="编码" >
            <el-input v-model.number="formValue.shipping_code" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
          <el-col :span="12">
            <vue-ueditor-wrap v-model="content" :config="myConfig" :readyOnly='true'></vue-ueditor-wrap>
            <div class="imgBox" v-html="imgContent"></div>
          </el-col>
          <el-col :span="12">
          <el-form-item prop="is_enable" class="formItemFill is_enable" label="是否启用" >
            <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="shipping_desc" class="formItemFill" label="快递描述">
        <el-input v-model="formValue.shipping_desc" size="small" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">提交</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { WebsiteService } from '../../service/website.service';
import VueUeditorWrap from 'vue-ueditor-wrap'
import { Message } from 'element-ui';

  export default {
    name: 'formRotationChart',
    components: { VueUeditorWrap  },
    data() {
      return {
        ue: '',
        content: '',
        myConfig: {
          toolbars:[['insertimage']],
        // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 400,
          // 初始容器宽度
          initialFrameWidth: '100%',
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          //serverUrl: 'http://35.201.165.105:8000/controller.php',
          serverUrl: 'https://api.goodyiyao.cn/index.php/api/File_logic/upload?action=config&action=uploadimage&encode=utf-8&path_type=slide',
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: '/ue/'
        },
        visible: false,
        openType: '',
        formValue: { },
        checkAll: false,
        event_type:'',
        img_url:'',
        rules: {
          shipping_name: [{ required: true, message: '快递名称不能为空'}],
          shipping_code: [{ required: true, message: '快递编码不能为空'}]
        },
      }
    },
    methods: {
      async open(type, data, platform,event_type) {
        this.platform = platform
        this.event_type = event_type
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit' && data) {
          const dataDetail = await WebsiteService.getShippingListDetail(data.shipping_id)
          this.content = '<img src='+dataDetail.shipping_logo+'>'
          this.formValue = JSON.parse(JSON.stringify(dataDetail))
        }
        this.openType = type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          is_enable: true,
          sort: 50,
          shipping_logo: ''
        };
      },
      async submit() {
          this.formValue.shipping_logo = this.imgContent.match('(?<=src=").[^"]*')[0].split('api.goodyiyao.cn/')[1]
          this.formValue.is_enable = this.formValue.is_enable ? 1 :0
          await WebsiteService.submitShipping(this.formValue);
          this.$emit('submitSuccess')
          this.close();
      },
      handlePreview(file) {
        console.log(file);
      },
      // beforeUpload(file) {
      // },
      
      close() {
        this.visible = false;
        this.formValue = {};
        this.content = ''
      }
    },
    computed: {
      imgContent() {
        if(this.openType=='add'){
          if(this.content){
            let re = this.content.match(/<img.+?>/ig)
            if(re.length == 1) {
              return re[0]
            }
            return re[re.length-1]
          }
        }
        else{
          if(this.content){
            let re = this.content.match(/<img.+?>/ig)
            if(re.length == 1) {
              return re[0]
            }
            return re[re.length-2]
          }
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>

<style lang="scss">
  .formItemFill .el-dialog__wrapper{
    z-index: 2500!important;
  }
  .shipping{
    .el-dialog__wrapper{
      .upload.formItemFill{
        height: 8vw;
        position: relative;
        .el-upload-list__item{
          margin-top: 0;
        }
        .el-button{
          position: absolute;
          top: 0px;
          left: 120px;
        }
      }
      .is_enable.formItemFill{
        height: 8vw;
        .el-color-picker__trigger{
          width: 100%;
          height: 93px;
          margin-top: -3px;
          .el-color-picker__icon{
            display: none;
          }
        }
      }
    }
  }
</style>